var render = function render(){var _vm=this,_c=_vm._self._c;return _c('node-view-wrapper',{staticClass:"page-header"},[_c('node-view-content')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }